import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { PhoenixLinkedService, phoenixAuthTypes } from 'app/model/linkedservice/phoenix.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PhoenixLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                host: '*',
                port: '*',
                httpPath: '*',
                authenticationType: '*',
                username: '*',
                password: 'secret',
                enableSsl: '*',
                trustedCertPath: '*',
                useSystemTrustStore: '*',
                allowHostNameCNMismatch: '*',
                allowSelfSignedServerCert: '*',
                encryptedCredential: '*'
            }
        }
    }
})
export class PhoenixLinkedServiceAdapter extends LinkedServiceAdapter<PhoenixLinkedService> {
    protected modelConstructor(): new () => PhoenixLinkedService {
        return PhoenixLinkedService;
    }

    protected model(): IModel {
        return PhoenixLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: PhoenixLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.PhoenixLinkedService;
        properties.type = Metamodel.modelFor(PhoenixLinkedService).name;
        const password: Model.SecretBase = linkedService.authenticationType !== phoenixAuthTypes.Anonymous && linkedService.password ?
            passwordOrAKVtoSecretBase(linkedService.password, this.context) : undefined;
        properties.typeProperties = {
            host: linkedService.host,
            port: linkedService.port,
            httpPath: linkedService.httpPath,
            authenticationType: linkedService.authenticationType,
            username: linkedService.authenticationType !== phoenixAuthTypes.Anonymous ? linkedService.username : undefined,
            password,
            enableSsl: linkedService.enableSsl,
            trustedCertPath: linkedService.enableSsl ? linkedService.trustedCertPath : undefined,
            useSystemTrustStore: linkedService.enableSsl ? linkedService.useSystemTrustStore : undefined,
            allowHostNameCNMismatch: linkedService.enableSsl ? linkedService.allowHostNameCNMismatch : undefined,
            allowSelfSignedServerCert: linkedService.enableSsl ? linkedService.allowSelfSignedServerCert : undefined
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: PhoenixLinkedService): Promise<PhoenixLinkedService> {
        const properties = linkedServiceResource.properties as Model.PhoenixLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.PhoenixLinkedServiceTypeProperties = properties.typeProperties;

        linkedService.host = typeProperties.host;
        linkedService.port = typeProperties.port;
        linkedService.httpPath = typeProperties.httpPath;
        linkedService.authenticationType = typeProperties.authenticationType;
        linkedService.username = typeProperties.username;
        linkedService.password = secretBaseToPasswordOrAKV(typeProperties.password, typeProperties.authenticationType !== phoenixAuthTypes.Anonymous, this.context);
        linkedService.enableSsl = typeProperties.enableSsl;
        linkedService.trustedCertPath = typeProperties.trustedCertPath;
        linkedService.useSystemTrustStore = typeProperties.useSystemTrustStore;
        linkedService.allowHostNameCNMismatch = typeProperties.allowHostNameCNMismatch;
        linkedService.allowSelfSignedServerCert = typeProperties.allowSelfSignedServerCert;

        return linkedService;
    }
}
